import BaseOnboarding from './BaseOnboarding';

const AnalyticEvents = {
  CLOSE: 'MANAGE_GROUPS_CLOSE',
  SHOW: 'MANAGE_GROUPS_SHOW',
};

// Initialize the ExpManageGroups instance
const ExpManageGroups = new BaseOnboarding({
  // Use the manageGroups mode
  mode: 'manageGroups',

  // Look for url parameters prefixed with 'grp_'
  urlParamPrefix: 'grp_',
});

// Bind up the widget to send the appropriate analytic events when certain events occur
ExpManageGroups.on('show', (config) => {
  ExpManageGroups.analytics.sendEvent(AnalyticEvents.SHOW, config);
}).on('close', () => {
  ExpManageGroups.analytics.sendEvent(AnalyticEvents.CLOSE);
});

export default ExpManageGroups;
